export const COPY_LINK = {
    id: 'oe.knovio.copyPreviewLink',
    description: 'Button label',
    defaultMessage: 'Copy Link'
};

export const LAUNCH_PREVIEW = {
    id: 'oe.knovio.launchPreviewLink',
    defaultMessage: 'Launch Preview',
    description: 'Button label',
};

export const LOADING_PREVIEW = {
    id: 'oe.knovio.previewLinkLoading',
    defaultMessage: 'Loading Preview…',
    description: 'Info text'
};

export const PREVIEW_LINK_LOADED = {
    id: 'oe.knovio.previewLinkLoaded',
    defaultMessage: 'A preview of your Passport Replay will open in a new browser window.',
    description: 'Info text'
};